export default [
    'Charitable Giving',
    'Gifts to Family & Friends'
  ]